import { useAuth } from '@/hooks/useAuth';
import { useWalletBalanceInfo } from '@/hooks/useWalletBalancesInfo';
import { getTools } from '@lifi/sdk';
import { LiFiWidget, useWidgetEvents, WidgetEvent, WidgetTheme } from '@lifi/widget';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useBalance } from 'wagmi';
const widgetTheme: WidgetTheme = {
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#111111',
        },
        secondary: {
          main: '#747474',
        },
        background: {
          default: '#ffffff',
          paper: '#f8f8fa',
        },
        text: {
          primary: '#00070F',
          secondary: '#6A7481',
        },
        grey: {
          200: '#EEEFF2',
          300: '#D5DAE1',
          700: '#555B62',
          800: '#373F48',
        },
        playground: {
          main: '#f3f5f8',
        },
      },
    },
  },
  container: {
    border: '1px solid rgb(234, 234, 234)',
    borderRadius: '16px',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '32px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: '32px',
        },
      },
    },
  },
};

export const LifiWidget = () => {
  const { data: tools } = useQuery({
    queryKey: ['lifi-widget-tools'],
    queryFn: () => getTools(),
  });
  const { exchanges } = tools ?? { exchanges: [] };
  const { address } = useAuth();

  const { refetch } = useBalance({
    address: address ?? undefined,
  });
  const { refetchBalance } = useWalletBalanceInfo(address ?? '');

  const widgetEvents = useWidgetEvents();
  useEffect(() => {
    const onRouteExecutionCompleted = () => {
      refetch();
      refetchBalance();
    };

    widgetEvents.on(WidgetEvent.RouteExecutionCompleted, onRouteExecutionCompleted);

    return () => widgetEvents.all.clear();
  }, [widgetEvents, refetch, refetchBalance]);
  return (
    <LiFiWidget
      theme={widgetTheme}
      integrator="Plume"
      appearance="light"
      slippage={0.01}
      buildUrl={true}
      exchanges={{ deny: exchanges.map((exchange) => exchange.key) ?? [] }}
    />
  );
};
